/* eslint-disable jsx-a11y/interactive-supports-focus */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { Tooltip } from "react-bootstrap";
import { Link } from "react-router-dom-v5-compat";
import { url } from "../../utils";
import CustomOverlayTrigger from "../CustomOverlayTrigger";

type Props = {
  name: string;
  link?: string;
  id: string | number;
  onRemove?: $TSFixMeFunction;
  withTooltip?: boolean;
};

export function Chip({ id, name, link, onRemove, withTooltip }: Props) {
  const handleRemoveClicked = (e: $TSFixMe) => {
    e.preventDefault();
    e.stopPropagation();
    // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
    onRemove(id);
  };

  const chip = (
    <div
      className="chip"
      role="button"
      tabIndex={withTooltip ? 0 : undefined}
      onClick={
        /* istanbul ignore next */ (e) => {
          e.preventDefault();
          e.stopPropagation();
        }
      }
    >
      {link ? (
        <Link className="chip-clickable" to={url(link)}>
          {name}
        </Link>
      ) : (
        <span>{name}</span>
      )}
      {onRemove && (
        <button
          data-testid="chip-remove-button"
          type="button"
          onClick={handleRemoveClicked}
          className="icon-eh-close"
        />
      )}
    </div>
  );

  if (!withTooltip) return chip;

  return (
    <CustomOverlayTrigger
      placement="bottom"
      overlay={<Tooltip id="tooltip">{name}</Tooltip>}
    >
      {chip}
    </CustomOverlayTrigger>
  );
}

export default Chip;
